// saga/authSaga.js

import { call, takeLeading } from "redux-saga/effects";
import axios from "axios";
import * as actionTypes from "../actionTypes";
import Swal from "sweetalert2"
import { api_urls } from "../../utils/api-urls";
import { admin_login } from "../../utils/api-routes";

function* adminLogin(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + admin_login}`, payload?.data);
        console.log("Admin Login Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Login Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            localStorage.setItem("token", data.token);
            localStorage.setItem("userId", data.userId);
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error?.response?.data?.message.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
            text: "Failed To Login",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Admin Login Saga Error ::: ", error?.response)
    }
}



export default function* authSaga() {
    yield takeLeading(actionTypes.ADMIN_LOGIN, adminLogin);
}